export default {
  REPLY: 'Відповісти',
  COMMENTS: 'Коментарі',
  WRITE_COMMENT: 'Напишіть коментар',
  THERE_ARE_NO_COMMENTS: 'Немає коментарів',
};
